import * as _ from 'underscore'

import { OpDataType, OpDataTypeInGroup } from '../../models/core'

import { UserSessionService, USER_SESSION_SERVICE_NAME } from '../user-session'


//#region Public Types

export const DATA_TYPE_SERVICE_NAME = 'DataTypeService'
export const DATA_TYPE_SERVICE_PROVIDER_NAME = 'DataTypeServiceProvider'

//#endregion


export class DataTypeService {

    //#region Ctor

    constructor(private userSessionService: UserSessionService) { }

    //#endregion


    public dataTypeToDataTypeInGroup(dataType: OpDataType): OpDataTypeInGroup {
        if (dataType != null) {
            const dataTypeInGroup: OpDataTypeInGroup = new OpDataTypeInGroup()

            dataTypeInGroup.idDataType = dataType.idDataType
            dataTypeInGroup.dataType = dataType
            dataTypeInGroup.idDataTypeGroup = 0

            return dataTypeInGroup
        }

        return null
    }
}

export class DataTypeServiceProvider implements ng.IServiceProvider {

    //#region IServiceProvider Implementation 

    public $get = [USER_SESSION_SERVICE_NAME, function (userSessionService: UserSessionService) {
        return new DataTypeService(userSessionService)
    }]

    //#endregion
} 